import { Injectable, Optional, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, Observable, BehaviorSubject } from 'rxjs';

import { ApiClientService } from '../../shared/services/api-client.service';
import { ICurrency } from '../../shared/interfaces/currency.interface';

import { IAccount } from './internal-accounts.service';

enum BULK_TRANSFER_TYPES {
  DOMESTIC = 'DOMESTIC',
  INTERNATIONAL = 'INTERNATIONAL'
}

enum BULK_TRANSFER_PURPOSES {
  SALARY_PAYMENTS = '0',
  ACCOUNT_PAYABLES = '1',
  SAVINGS_PLAN = '2',
  FOREIGN_BULK = '3'
}

interface IBulkPayment {
  orderRef?: string;
  transferDate: Date;
  chargeAccount: IAccount;
  amount: ICurrency;
  purpose: string;
  transactionPostingType: string;
  reference: string;
}

@Injectable({
  providedIn: 'root'
})
export class BulkTransferService extends ApiClientService {
  private onSubmit = new Subject<boolean>();
  private onConfirm = new Subject<boolean>();
  private orderReference = new Subject<string>();
  private metaFields = new Subject<IBulkPayment>();
  private onError = new Subject<string>();
  private purpose = new BehaviorSubject<BULK_TRANSFER_PURPOSES>(
    BULK_TRANSFER_PURPOSES.SALARY_PAYMENTS
  );

  constructor(
    http: HttpClient,
    @Optional() @Inject('resource') resource: string
  ) {
    super(http, resource);
  }

  setAmountExceedsLimitError(message: string) {
    this.onError.next(message);
  }

  getAmountExceedsLimitError(): Observable<string> {
    return this.onError.asObservable();
  }

  setMetaFields(fields: IBulkPayment) {
    this.metaFields.next(fields);
  }

  getMetaFields(): Observable<IBulkPayment> {
    return this.metaFields.asObservable();
  }

  setOnSubmit(isValid: boolean) {
    return this.onSubmit.next(isValid);
  }

  getOnSubmit(): Observable<boolean> {
    return this.onSubmit.asObservable();
  }

  setOnConfirm(isSet: boolean) {
    return this.onConfirm.next(isSet);
  }

  getOnConfirm(): Observable<boolean> {
    return this.onConfirm.asObservable();
  }

  setOrderReference(orderReference: string) {
    this.orderReference.next(orderReference);
  }

  getOrderReference(): Observable<string> {
    return this.orderReference.asObservable();
  }

  setPurpose(purpose: BULK_TRANSFER_PURPOSES) {
    this.purpose.next(purpose);
  }

  getPurpose(): Observable<BULK_TRANSFER_PURPOSES> {
    return this.purpose.asObservable();
  }

  getTransferType(purpose: string): BULK_TRANSFER_TYPES {
    return purpose === BULK_TRANSFER_PURPOSES.FOREIGN_BULK
      ? BULK_TRANSFER_TYPES.INTERNATIONAL
      : BULK_TRANSFER_TYPES.DOMESTIC;
  }
}

export { IBulkPayment, BULK_TRANSFER_TYPES, BULK_TRANSFER_PURPOSES };
